var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"x-large":"","block":"","depressed":"","color":_vm.slotIsSelected ? 'success' : ''},on:{"click":_vm.selectSlot}},[_vm._v(" "+_vm._s(_vm.slotTime)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }